import ItemIcons from "./ItemIcons";



class Item extends React.Component {
    constructor(props) {
        super(props);
        let nowDate;
        let dateText;
        let priceText;
        let image;
        let typeClass;
        let titleClass;
        if(this.props.status === "running"){
            nowDate = this.props.endDate;
                if(LANG['Lõppeb']){
                    dateText = LANG['Lõppeb']
                } else {
                    dateText = "Lõppeb";
                }
                if(LANG['Hind']){
                    priceText = LANG['Hind']
                } else {
                    priceText = "Hind";
                }
        } else if(this.props.status === "ended"){
            nowDate = this.props.endDate;
            if(LANG['Lõppenud']){
                dateText = LANG['Lõppenud']
            } else {
                dateText = "Lõppenud";
            }
            if(LANG['Lõpphind']){
                priceText = LANG['Lõpphind']
            } else {
                priceText = "Lõpphind";
            }
        }else if(this.props.status === "starting"){
            nowDate = this.props.startDate;
            if(LANG['Algab']){
                dateText = LANG['Algab']
            } else {
                dateText = "Algab";
            }
            if(LANG['Alghind']){
                priceText = LANG['Alghind']
            } else {
                priceText = "Alghind";
            }
        }else if(this.props.owner === "kv24" || this.props.owner === "city24" || this.props.owner === "soov"){
            nowDate = this.props.date;
            if(LANG['Kuupäev']){
                dateText = LANG['Kuupäev']
            } else {
                dateText = "Kuupäev";
            }
            if(LANG['Hind']){
                priceText = LANG['Hind']
            } else {
                priceText = "Hind";
            }
            titleClass=this.props.owner;
        } else if (this.props.type === "post") {
            nowDate = this.props.date;
            if(LANG['Aegub']){
                dateText = LANG['Aegub']
            } else {
                dateText = "Aegub";
            }
            if(LANG['Hind']){
                priceText = LANG['Hind']
            } else {
                priceText = "Hind";
            }
        } else {
            nowDate = this.props.date;
            if(LANG['Lõppeb']){
                dateText = LANG['Lõppeb']
            } else {
                dateText = "Lõppeb";
            }
            if(LANG['Hind']){
                priceText = LANG['Hind']
            } else {
                priceText = "Hind";
            }
        }



        if(this.props.subtype === '1' || this.props.subtype === 1){
            typeClass='type-kasvavmets';
            image = '/images/icons/type-kasvavmets.svg';
            titleClass='kasvav-mets';
        } else if(this.props.subtype === '2' || this.props.subtype === 2) {
            typeClass='type-kinnistud';
            image = '/images/icons/type-kinnistud.svg';
            titleClass='kinnistud';
        } else if (this.props.subtype === '4' || this.props.subtype === 4) {
            typeClass = 'type-materjal';
            image = '/images/icons/type-materjal.svg';
            titleClass='metsamaterjal';
        } else if(this.props.subtype === '5' || this.props.subtype === 5) {
            typeClass ='type-kinnisturent';
            image = '/images/icons/type-kinnisturent.svg';
            titleClass='pollumaa';
        } else if(this.props.owner === "kv24") {
            typeClass ='type-kv24';
            image = '/images/icons/type-universal.svg';
            titleClass='kv24';
        } else if(this.props.owner === "city24"){
            typeClass ='type-city24';
            image = '/images/icons/type-universal.svg';
            titleClass='city24';
        } else if(this.props.owner === "soov"){
            typeClass ='type-soov';
            image = '/images/icons/type-universal.svg';
            titleClass='soov';
        } else {
            typeClass='';
            image = '/images/icons/type-universal.svg';
            titleClass='';
        }

        if (this.props.type === "post"){
            typeClass+= " kuulutus";
        } else if(this.props.type === "auction"){
            typeClass+= " oksjon";
        }

        this.state = {
            id: this.props.id || '',
            owner: this.props.owner || '', // maaportaal, rmk, user, kv24, city24, soov
            type: this.props.type || '', // kuulutus, oksjon
            subtype: this.props.subtype || '', // Kasvav mets, kinnistud, rent, metsamaterjal
            status: this.props.status || '',
            name: this.props.name || '',
            county: this.props.county || '',
            price: this.props.price || '', // hind, alghind, lõpphind
            priceText: priceText,
            date: nowDate, // lisatud, lõppeb, lõppenud
            dateText: dateText,
            typeClass:typeClass,
            titleClass:titleClass,
            image:this.props.image || image,
            link: this.props.link || '',
            img: this.props.img || '',
            external_link: this.props.external_link || '', // city, kv24 link avab uues aknas
            bid: this.props.bid || ''
        };
    }

    render(item = this.state) {

        return (

            <React.Fragment>
                <section style={{order: this.props.index, cursor: 'pointer'}} className={`card ${this.state.typeClass} ${this.props.status}`}>
                    <a target={item.external_link ? '_blank' : '_self'}  href={item.external_link ? item.external_link : item.link}
                       className="big-icon-wrapper" onClick={() => {
                        if (this.state.typeClass.indexOf('type-kv24') !== -1) {
                            console.log('clicked kinnisvara24');
                            dataLayer.push({'event' : 'GAEvent', 'eventCategory' :'AdListing', 'eventAction' : 'kinnisvara24', 'eventLabel' : 'kinnisvara24_direct'});
                            
                        } else if (this.state.typeClass.indexOf('type-soov') !== -1) {
                            console.log('clicked soov');
                            dataLayer.push({'event' : 'GAEvent', 'eventCategory' :'AdListing', 'eventAction' : 'soov', 'eventLabel' : 'soov_direct'});

                        } else if (this.state.typeClass.indexOf('type-city24') !== -1) {
                            console.log('clicked city24');
                            dataLayer.push({'event' : 'GAEvent', 'eventCategory' :'AdListing', 'eventAction' : 'city24', 'eventLabel' : 'city24_direct'});
                        }
                       }}>
                        {item.bid === 'winning' ?
                            <section className="big-auction-block-status big-auction-block-status-winner">
                                {LANG['Oled kõrgeim pakkuja'] || 'Oled kõrgeim pakkuja'}
                            </section>
                            :''}
                        {item.bid === 'losing' ?
                            <section className="big-auction-block-status">
                                {LANG[' Sind on üle pakutud'] || ' Sind on üle pakutud'}
                            </section>
                            :''}
                    <ItemIcons icon={item.owner}/>
                    <section style={{backgroundSize: this.state.img !== '' ? 'cover' : '30%' }} data-url={`url(${this.state.img !== '' ? this.state.img : item.image})`} className={this.props.image? 'background-cover card-image lazy-loaded-image lazy' : 'background-30 card-image lazy-loaded-image lazy'} >
                    </section>
                        <section className="card-section">
                            {item.name && item.county ?
                                <React.Fragment>
                                    <h3 className={item.titleClass}>{item.name}</h3>
                                    <span>{item.county}</span>
                                </React.Fragment>
                                :
                                ''
                            }
                            {item.price.indexOf('-') != -1 ? '\xa0' : <span>{item.priceText}: <strong>{item.price}</strong></span>}
                            <span>{item.dateText}: <strong>{item.date}</strong></span>
                        </section>
                    </a>
                </section>
            </React.Fragment>
        )
    }
}

export default Item;
